import { Archive } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '../../../components/Button';
import { useAddToCvBank, useCvBankAccess, type CvBankPerson } from '../hooks/use-cv-bank-actions';

interface AddToCvBankButtonProps {
  readonly people: readonly CvBankPerson[];
  /** Clears the selection once the add has gone through. */
  readonly onDone?: () => void;
}

/**
 * ADR 0046 Q2 (b): "Add to CV Bank" in a selection bar. Renders nothing while the module is off
 * or for someone who cannot change candidates (#13), so the bar closes up around it.
 */
export function AddToCvBankButton({ people, onDone }: AddToCvBankButtonProps): ReactNode {
  const { canEdit } = useCvBankAccess();
  const { add, isPending } = useAddToCvBank();
  if (!canEdit || people.length === 0) return null;
  const unique = [...new Map(people.map((person) => [person.candidateId, person])).values()];
  return (
    <Button
      size="sm"
      variant="quiet"
      icon={Archive}
      isPending={isPending}
      onClick={() => {
        void add(unique, 'bulk').then((isAdded) => {
          if (isAdded) onDone?.();
        });
      }}
    >
      Add to CV Bank
    </Button>
  );
}
